module.exports = __webpack_public_path__ + "static/media/demo_page_image.3504e8e2.png";